import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function StackOverflowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M19.04 20.04v-5.87h1.99V22H3v-7.83h2v5.87h14.05-.01ZM6.98 18.09h10.05v-1.96H6.99v1.96Zm.25-4.45 9.8 2 .42-1.89-9.8-2.02-.41 1.9-.01.01ZM8.5 9l9.07 4.15.84-1.78L9.34 7.2 8.5 9V9Zm2.53-4.38 7.69 6.28 1.27-1.49-7.69-6.28-1.26 1.49ZM16.01 0l-1.64 1.2 6 7.87L22 7.88 16 0Z" />
    </SvgIcon>
  );
}
